import { render, staticRenderFns } from "./next-queries-config.component.vue?vue&type=template&id=348a79e4&scoped=true"
import script from "./next-queries-config.component.vue?vue&type=script&lang=ts"
export * from "./next-queries-config.component.vue?vue&type=script&lang=ts"
import style0 from "./next-queries-config.component.vue?vue&type=style&index=0&id=348a79e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348a79e4",
  null
  
)

export default component.exports